module.exports = __webpack_public_path__ + "images/cart-3P245Pq.svg";